import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import ReactTable from 'components/common/ReactTable';
import toastConfig from 'components/configuration/toast-config';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Swalcolor from 'components/configuration/sweetalert-config';
import { encodeData } from 'components/common/encodeParams';
import { errorMessage } from 'components/common/helper-function/catchErrorMessage';
import moment from 'moment';
import { getlocation, deletelocation } from 'services/manageEventsService'
import { useForm, Controller, set } from 'react-hook-form';
import { checkModulePermission } from 'components/common/helper-function/ModulePermissionCheck';
import { loaderContext } from 'context/Context';



export default function EventLocations() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [eventLocationData, setEventLocationData] = useState([]);
    const { isLoading, setIsLoading } = useContext(loaderContext)
    // const eventLocations = [{ id: "1", no: "1", eventLocation: "first floor", status: "Active", createdby: 'joseph', createOn: "2022-05-27 14:15" }, { id: "2", no: "2", eventLocation: "second floor", status: "Active", createdby: 'joseph', createOn: "2022-05-27 14:15" }, { id: "3", no: "3", eventLocation: "thrid floor", status: "Inactive", createdby: 'joseph', createOn: "2022-05-27 14:15" }, { id: "4", no: "4", eventLocation: "fouth floor", status: "Inactive", createdby: 'joseph', createOn: "2022-05-27 14:15" }]
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control,
        setValue,
        setError,
        clearErrors,
        watch
    } = useForm();


    // useEffect(() => {
    //     setEventLocationData(
    //         eventLocations.map(
    //             visit => {
    //                 // visit.createOn = new Date(visit.createOn);
    //                 return visit;

    //             }
    //         ));
    // }, [])

    useEffect(async () => {
        checkModulePermission("Event Locations")
        setIsLoading(true)
        try {
            const { data } = await getlocation();
            setEventLocationData(data.data)
        } catch (e) {
            errorMessage(e)
        }
        setIsLoading(false)
    }, [])



    const onEditRow = (id) => {
        const editdata = eventLocationData.find((event) => event.id === id)
        navigate(
            `/manageevents/event-locations/edit-location`, { state: { data: editdata } }
        );
        console.log("editdata", editdata)
    };
    const onDeleteRow = (id) => {
        Swal.fire({
            title: t(
                'departmentMaster.deleteDepartment.sweetAlert.confirmationTitle'
            ),
            text: t('departmentMaster.deleteDepartment.sweetAlert.confirmationText'),
            icon: 'warning',
            showCancelButton: Swalcolor.confirmation.showCancelButton,
            confirmButtonColor: Swalcolor.confirmation.confirmButtonColor,
            cancelButtonColor: Swalcolor.confirmation.cancelButtonColor,
            confirmButtonText: t(
                'departmentMaster.deleteDepartment.sweetAlert.confirmationBtnLabel'
            )
        }).then(async result => {
            if (result.isConfirmed) {
                setIsLoading(true)
                try {
                    const { data } = await deletelocation({ id });
                    console.log(data);
                    setEventLocationData(eventLocationData.filter(data => data.id != id));
                    Swal.fire({
                        icon: 'success',
                        title: t(
                            'departmentMaster.deleteDepartment.sweetAlert.simpleTitle'
                        ),
                        text: data?.message,
                        confirmButtonColor: Swalcolor.simple.confirmButtonColor
                    });
                } catch (e) {
                    errorMessage(e)
                }
                setIsLoading(false)
            }
        });
    };

    const columns = [
        {
            Header: t('eventLocation.label.no'),
            // accessor: 'id'
            accessor: (row, index) => index + 1,
        },
        {
            Header: t('eventLocation.label.eventLocation'),
            accessor: 'name'
        },
        {
            Header: t('eventLocation.label.status'),
            accessor: 'status'
        },
        {
            Header: t('eventLocation.label.createdby'),
            accessor: 'created_by'
        },
        {
            Header: t('eventLocation.label.createdOn'),
            accessor: 'created_on',
            Cell: ({ row }) => (
                row?.original?.created_on ? <div>
                    {moment.utc(row?.original?.created_on).local().format(process.env.REACT_APP_DATE_TIME_FORMAT)}
                </div> : "--   "
            ),
            // valueType: 'dateAndTime',
            // sortType: 'datetime',
            // disableGlobalFilter: true
        },
        {
            Header: t('eventLocation.label.action'),
            Cell: ({ row }) => (
                <div>
                    <span
                        className="btn p-0 me-2"
                        title="Edit"
                        onClick={() => onEditRow(row.original.id)}
                    >
                        <FontAwesomeIcon icon="edit" />
                    </span>
                    <span
                        className="btn p-0"
                        title="Delete"
                        onClick={() => onDeleteRow(row.original.id)}
                    >
                        <FontAwesomeIcon icon="trash-alt" />
                    </span>
                </div>
            ),
            disableSortBy: true
        }
    ];

    return (
        <>
            <div className="row g-3 mb-3">
                <div className="">
                    <div className="card overflow-hidden mb-3">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-xl-8 col-lg-6 col-md-4 ">
                                    <h3 className="heading-color fw-600 mb-0">
                                        {t('eventLocation.heading')}
                                    </h3>
                                </div>
                                <div className="col-xl-4 col-lg-6 col-md-8 table-btn" >
                                    <button
                                        className="btn btn-primary btn-sm float-end"
                                        onClick={() => {
                                            navigate('/manageevents/event-locations/add-location');
                                        }}
                                    >
                                        <span className="ms-1 d-sm-inline">
                                            {t('eventLocation.btnLabel.addEventLocation')}
                                        </span>
                                    </button>
                                </div>
                                <div className="col-12" >
                                    <hr />
                                </div>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <ReactTable
                                columns={columns}
                                data={eventLocationData}
                                pageSizeOption={[5, 10, 15, 20]}
                                headerClass="btn-primary"
                                isSearchBoxVisible={true}
                                isPaginationRequired={true}
                                ispaginationvisible={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
